import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@icons/classic/regular';
import { Button } from './Button';
import DropdownMenuGenerator from './DropdownMenuGenerator';
import type { ButtonProps } from './Button';
import type { DropdownMenuConfig } from './DropdownMenuGenerator';
interface OverflowMenuProps extends Omit<DropdownMenuConfig, 'trigger'> {
  buttonSize?: ButtonProps['size'];
  orientation?: 'horizontal' | 'vertical';
}
export default function OverflowMenu(t0) {
  const $ = _c(12);
  let dropdownMenuConfig;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      buttonSize: t1,
      orientation: t2,
      ...dropdownMenuConfig
    } = t0);
    $[0] = t0;
    $[1] = dropdownMenuConfig;
    $[2] = t1;
    $[3] = t2;
  } else {
    dropdownMenuConfig = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const buttonSize = t1 === undefined ? "icon" : t1;
  const orientation = t2 === undefined ? "vertical" : t2;
  const t3 = orientation === "vertical" ? "rotate-90" : "";
  let t4;
  if ($[4] !== t3) {
    t4 = <FontAwesomeIcon className={t3} icon={faEllipsis} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== buttonSize || $[7] !== t4) {
    t5 = <Button size={buttonSize} variant="quaternary">{t4}</Button>;
    $[6] = buttonSize;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== dropdownMenuConfig || $[10] !== t5) {
    t6 = <DropdownMenuGenerator config={{
      ...dropdownMenuConfig,
      trigger: t5
    }} />;
    $[9] = dropdownMenuConfig;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}